import noUiSlider from 'nouislider';

export default {
  init() {
    // JavaScript to be fired on the home page
    Number.prototype.format = function(n, x, s, c) {
      var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
          num = this.toFixed(Math.max(0, ~~n));
  
      return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
    };
  
    var rangePrecio = document.getElementById('rangePrecio');
    
    noUiSlider.create(rangePrecio, {
        start: [0, 9000000],
        step: 100,
        connect: true,
        range: {
            'min': 0,
            'max': 9000000,
        }
    });
    rangePrecio.noUiSlider.on('update', function (values, handle, unencoded, tap, positions, noUiSlider) { 

      $('.val-Precio').html( Number(values[0]).format(0, 3, '.', ',')+'€ hasta '+Number(values[1]).format(0, 3, '.', ',')+'€');
    });

    rangePrecio.noUiSlider.on('change', function (values, handle, unencoded, tap, positions, noUiSlider) { 
      $('#precio1').val(values[0]);
      $('#precio2').val(values[1]);
    });

    var rangeDistancia = document.getElementById('rangeDistancia');

    noUiSlider.create(rangeDistancia, {
        start: [3],
        step:1,
        connect: 'lower',
        range: {
            'min': 1,
            'max': 20
        }
    });

    $('.js-precio-movil-desde').change(function (e) { 
      $('#precio1').val(e.target.value);
    });

    $('.js-precio-movil-hasta').change(function (e) { 
      $('#precio2').val(e.target.value);
    });

    rangeDistancia.noUiSlider.on('update', function (values, handle, unencoded, tap, positions, noUiSlider) { 

      $('.val-distancia').html( Number(values[0]).format(0, 3, '.', ',')+'Km');
    });

    rangeDistancia.noUiSlider.on('change', function (values, handle, unencoded, tap, positions, noUiSlider) { 

      $('#distancia').val(values[0]);
    });

    $('.movil-precios-alquiler').hide();

    //evento cambiar tipo de operacion
    $('#tipo_operacion').change(function (e) { 
      e.preventDefault();
      console.log('cambia tipo de operacion', e.target.value);
      if( e.target.value == 'OPE_A'){
        rangePrecio.noUiSlider.updateOptions({
            range: {
                'min': 0,
                'max': 10000
            }
        });
        rangePrecio.noUiSlider.set([null, 10000]);

        $('.movil-precios-venta').hide();
        $('.movil-precios-alquiler').show();
      }else{
        rangePrecio.noUiSlider.updateOptions({
            range: {
                'min': 0,
                'max': 9000000
            }
        });
        rangePrecio.noUiSlider.set([null, 9000000]);
        $('.movil-precios-venta').show();
        $('.movil-precios-alquiler').hide();
      }
    });



    

    initAutocomplete();

    

    $('.js-buscar').click(function (e) { 
      e.preventDefault();
      var qs = '#';
      // qs += $('#lat').val() + '/';
      // qs += $('#lng').val() + '/';
      // qs += $('#distancia').val() + '/';
      // qs += $('#page').val() + '/';
      // qs += $('#precio1').val() + '/';
      // qs += $('#precio2').val() + '/';
      // qs += $('#tipo_operacion').val() + '/';
      // qs += $('#tipo_vivienda').val() + '/';
      // qs += $('#estado').val() + '/';
      // qs += $('#tamano').val()+ '/';
      // qs += $('#pac-input').val();


      var operacion = $('#tipo_operacion').val();
      if(operacion == 'OPE VENTA-ALQUILER'){
        operacion = 'venta-alquiler';
      }else if(operacion == 'OPE_A'){
        operacion = 'alquiler';
      }else if(operacion == 'OPE_V'){
        operacion = 'venta';
      }else{
        operacion = '';
      }

      qs += operacion + '/';
      qs += $('#tipo_vivienda').val() + '/';
      qs += $('#pac-input').val() + '/';
      qs += $('#estado').val() + '/';
      qs += $('#lat').val() + '/';
      qs += $('#lng').val() + '/';
      qs += $('#distancia').val() + '/';
      qs += $('#page').val() + '/';
      qs += $('#precio1').val() + '/';
      qs += $('#precio2').val() + '/';
      qs += $('#tamano').val()+ '/';


      console.log(qs);
      self.location = '/busqueda/'+qs;
    });


    




  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};

function initAutocomplete() {
      
  // Create the search box and link it to the UI element.
  const input = document.getElementById("pac-input");
  const searchBox = new google.maps.places.SearchBox(input);

  // Listen for the event fired when the user selects a prediction and retrieve
  // more details for that place.
  searchBox.addListener("places_changed", () => {
    const places = searchBox.getPlaces();

    if (places.length == 0) {
      return;
    }

    var place = places[0];

    $('#lat').val(place.geometry.location.lat());
    $('#lng').val(place.geometry.location.lng());
  });


  
}


function getSearchParams(){
  var url = self.location.href;
  var qs = url.split('#');
  if(qs.length<=1){
    return false;
  }
  var params = qs[1].split('/');

  var data = {
    action: 'homeBuscar',
    lat: params[0],
    lng: params[1],
    distancia: params[2],
    page: params[3],
    precio1: params[4],
    precio2: params[5],
    tipo_operacion: decodeURI(params[6]),
    tipo_vivienda: decodeURI(params[7]),
    estado: decodeURI(params[8]),
    tamano: params[9],
    localizacion: decodeURI(params[10])
  };
  return data;
}


// WEBPACK FOOTER //
// ./scripts/routes/home.js